import * as yup from 'yup'

const schema = {
  email: yup.string().email().required().trim(),
  password: yup.string().required(),
}

export const loginValidationSchema = yup.object().shape(schema)
